// extracted by mini-css-extract-plugin
module.exports = {"tempStyle":"dashboardSidebar_tempStyle__7QBYK"};